const TOKEN_KEY = 'access_token'
const REFRESH_TOKEN_KEY = 'refresh_token'

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
**/
const TokenService = {
    getToken() {
        return localStorage.getItem(TOKEN_KEY)
    },

    saveToken(accessToken) {
        localStorage.setItem(TOKEN_KEY, accessToken)
    },

    removeToken() {
        localStorage.removeItem(TOKEN_KEY)
    },

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY)
    },

    saveRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken)
    },

    removeRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_KEY)
    },

    getTokenObject() {
        let token = this.getToken();

        if (token == null) return null

        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        //console.log(JSON.parse(jsonPayload))

        return JSON.parse(jsonPayload);
    },

    idCompany() {
      let token = this.getTokenObject();
      if (token == null) return null;

      return token.CompanyId
    },

    companyName() {
      let token = this.getTokenObject();
      if (token == null) return null;

      return token.CompanyName
    },

    companyTypePublicCode() {
      let token = this.getTokenObject();
      if (token == null) return null;

      return token.CompanyTypePublicCode
    },

    companyEnergies() {
      let token = this.getTokenObject();
      if (token == null) return null;

      return token.CompanyEnergies
    },

    idUser() {
      let token = this.getTokenObject();
      if (token == null) return null;

      return token.UserId
    },

    idRole() {
      let token = this.getTokenObject();
      if (token == null) return null;

      return token.RoleId
    },

    isSuperAdmin() {
        let token = this.getTokenObject();
        if (token == null) return null;

        return token.RoleId == 'CAB19540-4F31-42F1-848A-EF661AE484AE' 
    },

    isAdmin() {
        let token = this.getTokenObject();
        if (token == null) return null;

        return token.CompanyTypePublicCode == 'service_company' && token.RoleId == '9D815702-5D0A-496B-A348-4F9681B1ED30'
    },

    isEnergyCompany() {
      let token = this.getTokenObject();
      if (token == null) return null;

      return token.CompanyTypePublicCode == 'energy_company'
    },

    isAdminEnergyCompany() {
      let token = this.getTokenObject();
      if (token == null) return null;

      return token.CompanyTypePublicCode == 'energy_company' && token.RoleId == '9D815702-5D0A-496B-A348-4F9681B1ED30'
    },

  isSuperUser() {
      let token = this.getTokenObject();
      if (token == null) return null;

      return token.CompanyTypePublicCode == 'service_company' && token.RoleId == '360981D2-40B4-406A-9557-D614F4A6487D'
  },

  isSuperEnergyUser() {
      let token = this.getTokenObject();
      if (token == null) return null;

      return token.CompanyTypePublicCode == 'energy_company' && token.RoleId == '360981D2-40B4-406A-9557-D614F4A6487D'
  },

  isUser() {
      let token = this.getTokenObject();
      if (token == null) return null;

      return token.CompanyTypePublicCode == 'service_company' && token.RoleId == 'CFA38251-B1BF-4B4C-91A8-8D9DC407E33F'
  },

  isEnergyUser() {
      let token = this.getTokenObject();
      if (token == null) return null;

      return token.CompanyTypePublicCode == 'energy_company' && token.RoleId == 'CFA38251-B1BF-4B4C-91A8-8D9DC407E33F'
  },

  isSimpleUser() {
      let token = this.getTokenObject();
      if (token == null) return null;

      return token.RoleId == null || token.RoleId == '65C31856-CB24-40AE-A858-4276719B5D2F'
  },

  isColdWaterPermission() {
    let token = this.getTokenObject();
    if (token == null) return null;

    return token.ColdWaterPermission
  },

  isHotWaterPermission() {
    let token = this.getTokenObject();
    if (token == null) return null;

    return token.HotWaterPermission
  },

  isHeatPermission() {
    let token = this.getTokenObject();
    if (token == null) return null;

    return token.HeatPermission
  },

  isElectricityPermission() {
    let token = this.getTokenObject();
    if (token == null) return null;

    return token.ElectricityPermission
  },

  isGasPermission() {
    let token = this.getTokenObject();
    if (token == null) return null;
    
    return token.GasPermission
  },
        
}

    

export { TokenService }